export enum UnsubscribeType {
  SUBMIT_PROFILE = 'SUBMIT_PROFILE',
  COMPLETE_TT = 'COMPLETE_TT',
  BOOK_TE_CALL = 'BOOK_TE_CALL',
}
